export const OutlookCalendarMutations = {
  setOutlookCalendarInfo: (state, data) => { state.calendarInfo = data },
  updateOutlookCalendarInfo: (state, data) => { state.calendarInfo = { ...state.calendarInfo, ...data } },
}
